<template>
  <div>

    <activity
      :location-ids="locationIds"
      :channels="channels"
    />

  </div>
</template>

<script setup lang="ts">

import { useI18n } from 'vue-i18n'
import { useTitle } from '@vueuse/core'

import Activity from './reports/Activity.vue'
import { Temporal } from '@js-temporal/polyfill'

/**
 * Props
 */

interface Props {
  locationIds: number[]
  channels?: string[]
  start: null | Temporal.PlainDate
  end: null | Temporal.PlainDate
}

withDefaults(defineProps<Props>(), {
  channels: () => [],
})

/**
 *
 */

const { t } = useI18n()
const title = useTitle()
title.value = t('titles.reporting_activity')

</script>
